import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PortalTemplatesService } from '../../infrastructure/services/portalTemplates.service';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'sx-listado-templates',
  templateUrl: './listado.siteTemplates.component.html',
})
export class ListadoSiteTemplatesComponent implements OnInit {
  @Input('capturarClickItem') capturarClickItem = false;
  @Output() itemClicked: EventEmitter<any> = new EventEmitter();

  codSistema: string;
  codNegocio: string;
  templates: Observable<ItemGeneralListado[]>;
  itemOver;
  constructor(private aRoute: ActivatedRoute, private portaService: PortalTemplatesService ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];

      this.templates = this.portaService.getPortalTeamplatesByNivel(this.codSistema, this.codNegocio);
    });
  }

  onItemClick(item) {
    this.itemClicked.emit(item);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/siteTemplates/listado.siteTemplates.component.ts